import React, { useEffect, useState } from "react";
import SearchBarWithIcon from "../../common/Modules/SearchBarWithIcon";
import Sort from "../../../assets/sort-svg.svg";
import Funnel from "../../../assets/funnel.svg";
import DownloadIcon from "../../../assets/dashboard/download_icon.svg";
import Refresh from "../../../assets/Refresh_icon.svg";
import RightArrow from "../../../assets/Rightarrow.svg";
import LeftArrow from "../../../assets/Leftarrow.svg";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { addQuery, displayListQueueButton } from "../Helper";
import "./dashboardAppointmentsViewHeader.scss";
import {
  SORT_MENU_ITEMS,
  APIFILTERLIST,
  APPLICABLE_ROLE,
  DEFAULT_DASHBOARD_PAYLOAD,
  DASHBOARD_VIEW,
  PRESCRIPTION_FILTER_ITEMS,
  PRESCRIPTION_KEYS,
} from "../Constant";
import { ClickAwayListener } from "@material-ui/core";
import FilterMenuList from "../../common/Modules/FilterMenuList";
import CustomeSelect from "../../common/Modules/CustomeSelect";
import DashboardDatePicker from "../../common/Modules/DashboardDatePicker";
import DatePicker from "../../common/Modules/DatePicker";
import ButtonGroupComponent from "../../common/Modules/ButtonGroup";
import DisabledSort from "../../../assets/disabled-sort-svg.svg";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../../Util/constants";
import dexie_db from "../../common/dexieDB";
import dateFormat from "dateformat";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import { c2cGetApiHandler } from "../../../Util/c2cApiHandler";
import { GET_TOTAL_BOOKED_APPOINTMENTS } from "../DashboardAppointmentsViewApiHandler/APIConstants";

const DashboardAppointmentsViewHeader = (props) => {
  const {
    sort_order,
    user_type,
    clinic_id,
    selectedDate,
    disableDownload,
    defaultDate,
    search_string,
    toggleFilterMenu,
    toggleDownloadFilterMenu,
    consultation_type,
    handleConsultationType,
    handleSortOrder,
    handleRefreshedData,
    downloadCallback,
    viewType,
    handleButtonGroup,
    callDashboardAppointmentsApi,
    clinicDropDownStatus,
    hasDownloadPermission,
  } = props;

  const history = useHistory();
  const location = useLocation();
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const [sort_menu, setSortMenu] = useState(SORT_MENU_ITEMS);
  const [prescriptionMenu, setPrescriptionMenu] = useState(
    PRESCRIPTION_FILTER_ITEMS
  );
  const [openMenu, setOpenMenu] = useState(false);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [openDownloadCalendar, setOpenDownloadCalendar] = useState(false);
  const [date, setDate] = useState("");
  const [openPresciptionFilter, setOpenPrescriptionFilter] = useState(false);
  const prescription_filter = new URLSearchParams(location.search).get(
    APIFILTERLIST.PRESCRIPTION_FILTER
  );
  const [loader, setLoader] = useState(true);
  const [calendarApiData, setCalendarApiData] = useState([]);

  // Lifecycle Methods ==>

  useEffect(() => {
    if (openCalendar) {
      handleCalendarMonthChange(dateFormat(new Date(), "yyyy-mm-dd"));
    }
  }, [openCalendar]);

  useEffect(() => {
    if (clinicDropDownStatus) {
      setOpenCalendar(false);
    }
  }, [clinicDropDownStatus]);

  useEffect(() => {
    prescriptionMenu.forEach((ele) => {
      ele.hide = false;
      if (
        ele.value === PRESCRIPTION_KEYS.LAB_PROCEDURES ||
        ele.value === PRESCRIPTION_KEYS.CLINIC_APPOINTMENTS
      ) {
        if (
          clinic_id &&
          (doctorRole === USER_ROLE.DOCTOR_ADMIN ||
            user_type == USER_TYPE.STAFF)
        ) {
          ele.hide = false;
        } else {
          ele.hide = true;
        }
      }
    });
    setPrescriptionMenu([...prescriptionMenu]);
  }, [clinic_id]);

  useEffect(() => {
    let selectedSort = sort_order
      ? sort_order
      : DEFAULT_DASHBOARD_PAYLOAD.sort_order;
    let arr = [];
    sort_menu.forEach((menu) => {
      arr.push({
        ...menu,
        selected: menu.value === selectedSort ? true : false,
      });
    });
    setSortMenu([...arr]);
  }, [sort_order]);

  useEffect(() => {
    if (selectedDate) {
      let today = selectedDate ? new Date(selectedDate) : new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let yyyy = today.getFullYear();
      const month = moment(today).format("MMM");
      const updatedDate = `${month} ${dd}, ${yyyy}`;
      setDate(updatedDate);
    }
  }, [selectedDate, clinic_id]);

  useEffect(() => {
    prescriptionMenu.forEach((item) => {
      if (prescription_filter === null && item.value === "all") {
        item.selected = true;
      } else {
        item.selected = item.value === prescription_filter ? true : false;
      }
    });
  }, [prescription_filter]);

  // <===

  // Action Methods ==>

  const toggleSortMenu = () => {
    setOpenMenu(!openMenu);
  };

  const togglePrescriptionFilter = () => {
    setOpenPrescriptionFilter(!openPresciptionFilter);
  };
  const closePrescriptionFilter = () => {
    setOpenPrescriptionFilter(false);
  };
  const toggleRefresh = () => {
    handleRefreshedData();
  };

  const handleCloseCalendar = () => {
    setOpenCalendar(false);
  };
  const handleClose = () => {
    setOpenMenu(false);
  };

  const handleOpenCalendar = () => {
    setOpenCalendar(!openCalendar);
  };

  const handleOpenDownloadCalendar = () => {
    setOpenDownloadCalendar(true);
  };

  const handleCloseDownloadCalendar = () => {
    setOpenDownloadCalendar(false);
  };

  const disableNext = () => {
    let tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let dd = String(tomorrow.getDate()).padStart(2, "0");
    let yyyy = tomorrow.getFullYear();
    const month = moment(tomorrow).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    if (moment(updatedDate).isSameOrBefore(moment().add(1, "years"))) {
      return false;
    }
    return true;
  };
  const handleNextDate = () => {
    let tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let dd = String(tomorrow.getDate()).padStart(2, "0");
    let yyyy = tomorrow.getFullYear();
    const month = moment(tomorrow).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    setDate(updatedDate);
    let formattedDate = moment(updatedDate).format("YYYY-MM-DD");
    addQuery(
      history,
      location,
      [APIFILTERLIST.STARTDATE, APIFILTERLIST.PAGENO],
      [`${formattedDate.toString()}`, 1]
    );
    handledashboardApiCall(formattedDate);
  };

  const handlePreviousDate = () => {
    let prevDate = new Date(date);
    prevDate.setDate(prevDate.getDate() - 1);
    let dd = String(prevDate.getDate()).padStart(2, "0");
    let yyyy = prevDate.getFullYear();
    const month = moment(prevDate).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    setDate(updatedDate);
    let formattedDate = moment(updatedDate).format("YYYY-MM-DD");
    addQuery(
      history,
      location,
      [APIFILTERLIST.STARTDATE, APIFILTERLIST.PAGENO],
      [`${formattedDate.toString()}`, 1]
    );
    handledashboardApiCall(formattedDate);
  };
  // <===

  // Helper Methods ==>

  const tileContent = ({ date, view }) => {
    let calenderDate = moment(date).format("YYYY-MM-DD");
    if (view === "month") {
      let appointments = calendarApiData.find(
        (item) => item.appointment_day === calenderDate
      );
      if (appointments) {
        return (
          <div className="total-appointments-text-box">
            {appointments.total_appointments}
          </div>
        );
      }
    }
  };

  const handledashboardApiCall = async (val) => {
    let tempDbData = await dexie_db.appointment.get(
      clinicId ? clinicId : "default"
    );
    if (tempDbData?.hasOwnProperty(val)) {
      callDashboardAppointmentsApi({
        [APIFILTERLIST.STARTDATE]: val,
        [APIFILTERLIST.PAGENO]: 1,
      });
    }
  };

  const menuItemSelectCallback = (data) => {
    let sortval;
    SORT_MENU_ITEMS.forEach((item) => {
      item.selected = false;
      if (item.value === data.value) {
        sortval = item.value;
        item.selected = true;
      }
    });
    addQuery(
      history,
      location,
      [APIFILTERLIST.SORTORDER, APIFILTERLIST.PAGENO],
      [`${sortval}`, 1]
    );
    handleSortOrder(sortval);
    handleClose();
  };

  const prescriptionFilterSelect = (data) => {
    let presc_filter;
    prescriptionMenu.forEach((item) => {
      item.selected = false;
      if (item.value === data.value) {
        presc_filter = item.value;
        item.selected = true;
      }
    });
    addQuery(
      history,
      location,
      [APIFILTERLIST.PRESCRIPTION_FILTER, APIFILTERLIST.PAGENO],
      [`${presc_filter}`, 1]
    );
    closePrescriptionFilter();
  };

  const inputCallBack = (val) => {
    addQuery(
      history,
      location,
      [APIFILTERLIST.SEARCHSTRING, APIFILTERLIST.PAGENO],
      [`${val}`, 1]
    );
  };

  const dateInputCallBack = (val) => {
    let formattedDate = moment(val).format("YYYY-MM-DD");
    val.setDate(val.getDate());
    let dd = String(val.getDate()).padStart(2, "0");
    let yyyy = val.getFullYear();
    const month = moment(val).format("MMM");
    const updatedDate = `${month} ${dd}, ${yyyy}`;
    setDate(updatedDate);
    addQuery(
      history,
      location,
      [APIFILTERLIST.STARTDATE, APIFILTERLIST.PAGENO],
      [`${formattedDate.toString()}`, 1]
    );
    setOpenCalendar(false);
    handledashboardApiCall(formattedDate);
  };

  const getClassName = () => {
    return user_type === APPLICABLE_ROLE.STAFF ? "pt-0" : "pt-3";
  };

  const applyRange = (range) => {
    handleCloseDownloadCalendar();
    downloadCallback(range);
  };

  const Backdrop = ({ onClick }) => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: "1",
      }}
      onClick={onClick}
    />
  );

  // API calls ==>

  const handleCalendarMonthChange = (value) => {
    if (
      doctorRole === USER_ROLE.RESOURCE_ADMIN ||
      userType === USER_TYPE.STAFF
    ) {
      setLoader(false);
      setCalendarApiData([]);
    } else {
      setLoader(true);
      var month = moment(value).format("M");
      var year = moment(value).format("YYYY");
      let payload = {
        doctor_id: doctorId,
        clinic_id: clinicId,
        month: month,
        year: year,
      };

      c2cGetApiHandler(GET_TOTAL_BOOKED_APPOINTMENTS, payload).then(
        ([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setLoader(false);
              setCalendarApiData(res.data.data);
            } else {
              setLoader(false);
              setCalendarApiData([]);
            }
          } else {
            C2CConsole.log("Error Occured");
            setLoader(false);
          }
        }
      );
    }
  };

  // Create UI ==>

  const displayDashboardAppointmentsViewHeader = () => {
    return (
      <div className="container-fluid mb-3 px-sm-0  px-lg-3 px-0">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center w-100 dashboard-view-header-mobile-view">
            {window.innerWidth < 767 && renderDashboardTitle()}
            <div
              className={
                "d-flex ai-center w-100 " +
                (window.innerWidth < 768 ? "col-sm-7 col-7 pr-0" : "")
              }
            >
              {window.innerWidth > 767 && renderDatePicker()}
              {doctorRole !== USER_ROLE.RESOURCE_CONSULTANT &&
                doctorRole !== USER_ROLE.RESOURCE_ADMIN &&
                renderConsultationTypeDropdown()}
              {window.innerWidth > 767 &&
                displayListQueueButton(consultation_type, selectedDate) &&
                renderButtonGroup()}
            </div>
            {renderSummarySearchFilter()}
          </div>
        </div>
        {window.innerWidth < 767 &&
          displayListQueueButton(consultation_type, selectedDate) &&
          renderButtonGroup()}
        {displaySearchMobileView()}
        {displayMobileViewFilter()}
      </div>
    );
  };

  const renderDashboardTitle = () => {
    return (
      <div
        className={
          "col-sm-3 col-lg-2 dashboard-header-mobile-view " +
          (window.innerWidth > 767 ? "pl-4 pt-4" : "pl-3 " + getClassName())
        }
      >
        <span className="dashboard-appointments-view-header-title">
          Appointments
        </span>
      </div>
    );
  };

  const renderDatePicker = () => {
    return (
      <div
        className={
          "dashboard-header-mobile-view d-flex " +
          (window.innerWidth > 767 ? "pt-4" : "pl-3 " + getClassName())
        }
        style={{ position: "relative", marginRight: "10px" }}
      >
        <p onClick={handleOpenCalendar} className="calendar pt-3">
          {date}
        </p>{" "}
        <img
          src={LeftArrow}
          alt="Left"
          onClick={handlePreviousDate}
          style={{
            height: "15px",
            cursor: "pointer",
            color: "black",
            marginLeft: "5px",
            marginTop: "20px",
          }}
        />
        <div
          style={{
            cursor: disableNext() ? "not-allowed" : "pointer",
          }}
        >
          <img
            src={RightArrow}
            alt="Right"
            onClick={handleNextDate}
            style={{
              height: "15px",
              color: "black",
              marginLeft: "5px",
              marginTop: "20px",
              pointerEvents: disableNext() ? "none" : "auto",
            }}
          />
        </div>
        {openCalendar && (
          <>
            <Backdrop onClick={handleCloseCalendar} />
            <DashboardDatePicker
              dateInputCallBack={(val) => dateInputCallBack(val)}
              maxDate={moment(new Date()).add(12, "months")._d}
              onCalendarMonthChange={handleCalendarMonthChange}
              tileContent={tileContent}
              loader={loader}
            />
          </>
        )}
      </div>
    );
  };

  const displayDatePicker = () => {
    return (
      openDownloadCalendar && (
        <>
          <Backdrop onClick={handleCloseDownloadCalendar} />
          <DatePicker
            closeDatePicker={handleCloseDownloadCalendar}
            applyRange={applyRange}
            title="Please select the date range for which you want to download the csv."
            rightButtonText="Download"
            defaultDate={defaultDate}
          />
        </>
      )
    );
  };

  const renderSummarySearchFilter = () => {
    return (
      <div
        className={
          "d-flex justify-content-end dashboard-header-search-mobile-view " +
          (window.innerWidth > 767 ? "pl-1 pt-4" : "pr-0 " + getClassName()) //pr-4
        }
      >
        <div
          className="d-sm-none d-lg-block d-none search-bar mr-2"
          style={{
            width: window.innerWidth > 1200 ? "295px" : "100%",
          }}
        >
          <SearchBarWithIcon
            inputCallBack={(val) => inputCallBack(val)}
            search_string={search_string}
            placeholder={
              clinic_id
                ? "Search by patient name, UHID, mobile number"
                : "Search by patient name or mobile number"
            }
            isClearable={true}
          />
        </div>

        {window.innerWidth > 767 && (
          <div className="dashboard-appointments-view-header-filter-container">
            <div
              className="d-flex align-items-center dashboard-appointments-view-filter"
              style={{
                height: "38px",
                width: "43px",
                position: "relative",
                justifyContent: "center",
              }}
            >
              <img
                src={DownloadIcon}
                alt="DownloadIcon"
                className={
                  !hasDownloadPermission ? "dashboard-disable-download" : ""
                }
                onClick={() =>
                  hasDownloadPermission &&
                  !disableDownload &&
                  handleOpenDownloadCalendar()
                }
              />
              {displayDatePicker()}
            </div>

            <div
              className={`d-flex align-items-center dashboard-appointments-view-filter ${
                viewType === DASHBOARD_VIEW.QUEUE ? "filter_disable" : ""
              }`}
              style={{
                height: "38px",
                width: "43px",
                justifyContent: "center",
              }}
            >
              <img
                src={viewType === DASHBOARD_VIEW.QUEUE ? DisabledSort : Sort}
                alt="Sort"
                onClick={toggleSortMenu}
              />
              {openMenu && (
                <ClickAwayListener onClickAway={handleClose}>
                  <div>
                    <FilterMenuList
                      menuItemList={sort_menu}
                      toggleItems={menuItemSelectCallback}
                    />
                  </div>
                </ClickAwayListener>
              )}
            </div>
            {(!doctorRole || !doctorRole.includes("resource")) && (
              <div
                className={`d-flex align-items-center dashboard-appointments-view-filter ${
                  viewType === DASHBOARD_VIEW.QUEUE ? "filter_disable" : ""
                }`}
                style={{
                  height: "38px",
                  width: "43px",
                  justifyContent: "center",
                }}
              >
                <img
                  src={Funnel}
                  alt="Sort"
                  style={{
                    opacity: viewType === DASHBOARD_VIEW.LIST ? 1 : 0.4,
                  }}
                  onClick={
                    viewType === DASHBOARD_VIEW.LIST
                      ? togglePrescriptionFilter
                      : undefined
                  }
                />

                {openPresciptionFilter && (
                  <ClickAwayListener onClickAway={closePrescriptionFilter}>
                    <div className="prescription_filter_menu">
                      <FilterMenuList
                        menuItemList={prescriptionMenu?.filter(
                          (ele) => !ele.hide
                        )}
                        toggleItems={prescriptionFilterSelect}
                        show_menu_title={PRESCRIPTION_KEYS.FILTER}
                        styles={{
                          minWidth: "243px",
                          minHeight: "241px",
                          font: "normal normal normal 13px/15px Rubik",
                        }}
                      />
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            )}
            <div
              className="d-flex align-items-center dashboard-appointments-view-filter"
              style={{
                height: "38px",
                width: "43px",
                justifyContent: "center",
              }}
            >
              <img src={Refresh} alt="Refresh" onClick={toggleRefresh} />
            </div>
          </div>
        )}
      </div>
    );
  };

  const displaySearchMobileView = () => {
    return (
      <div
        className={
          "d-sm-block d-lg-none d-md-block w-100 mt-3 search-bar " +
          (window.innerWidth > 767 && window.innerWidth < 990
            ? "pl-2 pr-2"
            : "pl-0 pr-0")
        }
      >
        <SearchBarWithIcon
          inputCallBack={(val) => inputCallBack(val)}
          search_string={search_string}
          placeholder={
            clinic_id
              ? "Search by patient name, UHID, mobile number"
              : "Search by patient name or mobile number"
          }
          isClearable={true}
        />
      </div>
    );
  };

  const displayMobileViewFilter = () => {
    return (
      <div className="d-sm-flex d-lg-none d-md-none w-100 mt-3 pl-4 pr-4 search-bar d-flex">
        <div
          className="d-sm-block d-lg-none d-md-none w-100 pt-1 pr-4  col-sm-2 d-flex"
          style={{ paddingLeft: "0px" }}
        >
          <p onClick={handleOpenCalendar} className="calendar pt-2">
            {date}
          </p>{" "}
          <img
            src={LeftArrow}
            alt="Left"
            onClick={handlePreviousDate}
            style={{
              height: "15px",
              cursor: "pointer",
              color: "black",
              marginLeft: "10px",
              marginTop: "10px",
            }}
          />
          <div
            style={{
              cursor: disableNext() ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={RightArrow}
              alt="Right"
              onClick={handleNextDate}
              style={{
                cursor: "pointer",
                height: "15px",
                color: "black",
                marginLeft: "5px",
                marginTop: "10px",
                pointerEvents: disableNext() ? "none" : "auto",
              }}
            />{" "}
          </div>
          {openCalendar && (
            <DashboardDatePicker
              dateInputCallBack={(val) => dateInputCallBack(val)}
              maxDate={moment(new Date()).add(12, "months")._d}
              onCalendarMonthChange={handleCalendarMonthChange}
              tileContent={tileContent}
              loader={loader}
            />
          )}
        </div>
        <div
          className="ml-4 justify-content-end pr-0 dashboard-appointments-view-header-filter-container"
          style={{ height: "40px" }}
        >
          <div
            className="d-flex align-items-center dashboard-appointments-view-filter justify-content-center"
            style={{ height: "40px", position: "relative" }}
          >
            <img
              src={DownloadIcon}
              alt="DownloadIcon"
              className={
                !hasDownloadPermission ? "dashboard-disable-download" : ""
              }
              onClick={() =>
                hasDownloadPermission &&
                !disableDownload &&
                toggleDownloadFilterMenu()
              }
            />
            {displayDatePicker()}
          </div>
          <div
            className={`d-flex align-items-center dashboard-appointments-view-filter justify-content-center ${
              viewType === DASHBOARD_VIEW.QUEUE ? "filter_disable" : ""
            } `}
            style={{ height: "40px" }}
          >
            <img
              src={viewType === DASHBOARD_VIEW.QUEUE ? DisabledSort : Sort}
              alt="Sort"
              onClick={toggleFilterMenu}
            />
          </div>
          <div
            className={`d-flex align-items-center dashboard-appointments-view-filter justify-content-center`}
            style={{
              height: "40px",
              opacity: viewType === DASHBOARD_VIEW.QUEUE ? 0.4 : 1,
            }}
          >
            <img
              src={Funnel}
              alt="Sort"
              onClick={
                viewType === DASHBOARD_VIEW.QUEUE ? undefined : toggleFilterMenu
              }
            />
          </div>
          <div
            className="d-flex align-items-center dashboard-appointments-view-filter justify-content-center"
            style={{ height: "40px" }}
          >
            <img src={Refresh} alt="Refresh" onClick={toggleRefresh} />
          </div>
        </div>
      </div>
    );
  };

  const renderConsultationTypeDropdown = () => {
    return (
      <div
        className={
          "col-sm-12 col-12 col-md-4 pt-4 pl-sm-0 pl-0 " +
          (window.innerWidth > 767 ? "pr-0 " : "pr-3 ") +
          (displayListQueueButton(consultation_type, selectedDate)
            ? "col-lg-5"
            : "col-lg-6")
        }
        style={{
          marginRight: "10px",
          minWidth: displayListQueueButton(consultation_type, selectedDate)
            ? "44.5%"
            : "",
        }}
      >
        <CustomeSelect
          consultation_type={consultation_type}
          handleConsultationType={handleConsultationType}
        />
      </div>
    );
  };

  const renderButtonGroup = () => {
    return (
      <div
        className="pt-4"
        style={{ marginLeft: doctorRole?.includes("resource") ? "10px" : "" }}
      >
        <ButtonGroupComponent
          activeButton={viewType}
          handleButtonGroup={handleButtonGroup}
        />
      </div>
    );
  };

  // <===

  return (
    <div className="dashboard-appointments-view-header px-3">
      {displayDashboardAppointmentsViewHeader()}
    </div>
  );
};

export default DashboardAppointmentsViewHeader;
